const validate = (values, props) => {
  const errors = {};

  if (!values.lastName) {
    errors.lastName = 'Required';
  }
  if (!values.email) {
    errors.email = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  if (!values.seatType) {
    errors.seatType = 'Required';
  }
  if (!values.childAge) {
    errors.childAge = 'Required';
  }

  if (!values.phone || values.phone.length < 5) {
    errors.phone = 'Required';
  }
  if (props.transfers.showFlightNumber && !values.flightNumber) {
    errors.flightNumber = 'Required';
  }
  if (props.transfers.fromAccommodation.show && !values.accommodationName) {
    errors.accommodationName = 'Required';
  }
  if (props.transfers.toAccommodation.show && !values.toAccommodationName) {
    errors.toAccommodationName = 'Required';
  }
  // if (!values.accommodationAddress) {
  //   errors.accommodationAddress = 'Required';
  // }
  // if (!values.toAccommodationAddress) {
  //   errors.toAccommodationAddress = 'Required';
  // }

  for (var i = 0; i < 10; i++) {
    if (!values[`childAge${i}`]) {
      errors[`childAge${i}`] = 'Required';
    }
    if (values[`childAge${i}`] > 15 || values[`childAge${i}`] < 0) {
      errors[`childAge${i}`] = 'Age must be between 0 and 15';
    }
    if (!values[`seatType${i}`]) {
      errors[`seatType${i}`] = 'Required';
    }
  }
  if (props.transfers.shuttle.showTimes && !values.busNumber) {
    errors.busNumber = 'Required';
  }
  if (props.transfers.shuttle.showFrom && !values.departureStop) {
    errors.departureStop = 'Required';
  }
  if (props.transfers.shuttle.showTo && !values.arrivalStop) {
    errors.arrivalStop = 'Required';
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TravelDetailsPanel/form/validatePageTwo.js